import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  name: "",
};

export const ChatUserNameSlice = createSlice({
  name: "chat_name",
  initialState,
  reducers: {
    chatUser: (state, action) => {
      state.name = action.payload;
    },
  },
});

export const { chatUser } = ChatUserNameSlice.actions;
export default ChatUserNameSlice.reducer;
